import { render } from "./user_resetpass.vue?vue&type=template&id=5c16ac62"
import script from "./user_resetpass.vue?vue&type=script&lang=js"
export * from "./user_resetpass.vue?vue&type=script&lang=js"

import "./user_resetpass.vue?vue&type=style&index=0&id=5c16ac62&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__